import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { TvController, TvControllerStatus } from '@/lib/schema/tvController';
import { Table } from '@tanstack/react-table';
import { CircleX } from 'lucide-react';
import { DataTableFacetedFilter } from '../boxes-list/data-table-faceted-filter';

export default function TvControllerFilter({
  table,
  tags,
}: {
  table: Table<TvController>;
  /** When provided, renders an inline faceted Tags filter. The ZeeVee
   *  dashboard omits this in favor of the left-hand tree selector. */
  tags?: string[];
}) {
  return (
    <div className="flex items-center pb-6 gap-2">
      <Input
        name="filter"
        autoComplete="off"
        placeholder="Search tv ..."
        // value={(table.getColumn('name')?.getFilterValue() as string) ?? ''}
        onChange={(event) => {
          table.setGlobalFilter(event.target.value);
        }}
        className="max-w-sm"
      />

      {tags && (
        <DataTableFacetedFilter
          title="Tags"
          column={table.getColumn('tags')}
          options={tags.map((tag) => ({
            value: tag,
            label: tag,
          }))}
        />
      )}

      {table.getColumn('status') && (
        <DataTableFacetedFilter
          column={table.getColumn('status')}
          title="Status"
          options={[
            {
              value: TvControllerStatus.UNKNOWN,
              label: 'Unknown',
            },
            {
              value: TvControllerStatus.OK,
              label: 'Online',
            },
            {
              value: TvControllerStatus.OFFLINE,
              label: 'Offline',
            },
          ]}
        />
      )}

      {table.getState().columnFilters.length > 0 && (
        <Button
          variant="ghost"
          onClick={() => table.resetColumnFilters()}
          className="h-8 px-2 lg:px-3"
        >
          Reset
          <CircleX className="ml-2 h-4 w-4" />
        </Button>
      )}
    </div>
  );
}
